/* eslint-disable react/jsx-closing-bracket-location */
import { connect } from 'react-redux';
import { compose } from 'redux';
import { filterIds } from '../utils/filterIds';

const withDisplayedLayersCheckHOC = (Component, layerId) => props => filterIds(props.displayedLayers, layerId)
    .map(layer => <Component
        key={layer.id}
        {...props}
        layer={layer}
    />
    );
const mapStateToProps = ({ displayedLayers }) => ({ displayedLayers });

export const withDisplayedLayersCheck = compose(connect(mapStateToProps), withDisplayedLayersCheckHOC);
